import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './MarkedForDesignersModuleContainer'
import Enhancer from './MarkedForDesignersModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import GridLayout from 'Components/GridLayout'
import LayoutButtonGroup from 'Components/LayoutButtonGroup'
import Pagination from 'Components/Pagination'
import PreviewModal from 'Components/PreviewModal'
import TableLayout from 'Components/TableLayout'

import * as styles from './styles'

const MarkedForDesignersModule = props => {
  const {
    handleExportToExcel,
    handleSort,
    layout,
    limit,
    pagination,
    previewOpen,
    rugs,
    setPage,
    sortBy,
    sortOrder,
    toggleLayout,
    toggleLimit,
    togglePreview,
    toggleSortOrder,
    user,
  } = props

  return (
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column width={16}>
          <Segment style={styles.rugCardsSegment}>
            <LayoutButtonGroup
              exportToExcel={handleExportToExcel}
              layout={layout}
              handleSort={handleSort}
              limit={limit}
              sortBy={sortBy}
              sortOrder={sortOrder}
              toggleLayout={toggleLayout}
              toggleLimit={toggleLimit}
              toggleSortOrder={toggleSortOrder}
            />

            {layout === 'gridLayout' && rugs.length > 0 && (
              <GridLayout fromPage="markedForDesigners" rugs={rugs} searchForm={false} togglePreview={togglePreview} enablePreview />
            )}

            {layout === 'tableLayout' && rugs.length > 0 && (
              <TableLayout
                fromPage="markedForDesigners"
                rugs={rugs}
                handleSort={handleSort}
                sortBy={sortBy}
                sortOrder={sortOrder}
                toggleSortOrder={toggleSortOrder}
                user={user}
              />
            )}

            {rugs.length > 0 && (
              <div>
                <br />

                <Pagination itemName="rug" items={pagination.totalRugs} page={pagination.page} pages={pagination.pages} setPage={setPage} />
              </div>
            )}

            <ErrorMassive enabled={rugs.length === 0} message="No rugs found." />
          </Segment>

          {previewOpen && <PreviewModal open={previewOpen} rugs={rugs} toggle={togglePreview} />}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

MarkedForDesignersModule.propTypes = {
  allRugs: PropTypes.array.isRequired,
  exportToExcel: PropTypes.func.isRequired,
  getRugs: PropTypes.func.isRequired,
  handleExportToExcel: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  layout: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired,
  pagination: PropTypes.object.isRequired,
  previewOpen: PropTypes.bool.isRequired,
  rugs: PropTypes.array.isRequired,
  rugsDone: PropTypes.bool.isRequired,
  rugsError: PropTypes.bool.isRequired,
  rugsPending: PropTypes.bool.isRequired,
  setPage: PropTypes.func.isRequired,
  setSortBy: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  toggleLayout: PropTypes.func.isRequired,
  toggleLimit: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
  toggleSortOrder: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const composed = compose(
  withPermissions('modules.markedForDesigners'),
  Enhancer,
  Container,
  StandardLoader('Looking for the rug…'),
  StandardError,
)

export default composed(MarkedForDesignersModule)
